import React from 'react'
import './Footer.css'
import Instagram from '@iconscout/react-unicons/icons/uil-instagram'
import StreamMusic from '@iconscout/react-unicons/icons/uil-music-note'
import Video from '@iconscout/react-unicons/icons/uil-video'
import Home from '@iconscout/react-unicons/icons/uil-home'
import Bio from '@iconscout/react-unicons/icons/uil-book'
import Podcast from '@iconscout/react-unicons/icons/uil-microphone'
import GiveIcon from '@iconscout/react-unicons/icons/uil-heart-alt'
import FooterBackground from '../../img/footerbackground.png'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className="footer">
        <img src={FooterBackground} alt="" style={{width: '100%'}} />
        <div className="f-content">
            <a
              href="https://mailchi.mp/7d2f18a7f168/join-peacetribe-newsletter"
              target="_blank"
              rel="noopener noreferrer"
              className="newsletterButton"
            >
              Join Peace Tribe's Newletter ◑
            </a>
            <div className="f-icons">

            <Link to='/' className='homeButton'>
                <Home color='white' size='3rem'/>
                </Link>
                
                <Link to='/bio' className='bio'>
                <Bio color='white' size='3rem'/>
                </Link>

                <a href='https://www.instagram.com/kushimofficial/' target="_blank" rel="noopener noreferrer" className='instagramLink'>
                  <Instagram color='white' size='3rem'/>

                </a>

                <a href='https://www.submithub.com/link/kushim' target="_blank" rel="noopener noreferrer" className='musicLink'>
                  <StreamMusic color='white' size='3rem'/>
                </a>

                <a href='https://www.youtube.com/c/KushimOfficial/featured' target="_blank" rel="noopener noreferrer" className='youtubeLink'>
                <Video color='white' size='3rem'/>
                </a>

                <Link to='/podcast' className='podcastButton'>
                  <Podcast color='white' size='3rem'/>
                </Link>

                <a
                  href='https://mailchi.mp/7d2f18a7f168/join-peacetribe-newsletter'
                  target="_blank"
                  rel="noopener noreferrer"
                  className='newsletterIcon'
                >
                  <span>✉</span>
                </a>

                <Link to='/give' className='giveButton'>
                  <GiveIcon color='white' size='3rem'/>
                </Link>

                <span className='createdByMobileVersion'> Website Created By Kushim </span>
            </div>
            <span className='createdBy'> Website Created By Kushim </span>
        </div>
    </div>
  )
}

export default Footer